import axios from "axios";
import { gql } from "graphql-request";

import { deleteUtmParamsFromCookie } from "@krea/customer-features/services/queryParamsService";
import { IApplicationPayload } from "@krea/customer-features/store/loan-application-form/utils";

const LOAN_APPLICATION_CREATE_MUTATION = gql`
  mutation CreateLoanApplication($input: CreateApplicationInput!) {
    createLoanApplication(input: $input) {
      __typename
      ... on OperationInfo {
        messages {
          message
          code
          kind
          field
        }
      }
      ... on NoContent {
        ok
      }
    }
  }
`;

interface ILoanApplicationCreateResponse {
  createLoanApplication: {
    __typename: string;
    messages: {
      message: string;
      code: string;
      kind: string;
      field: string;
    }[];
    ok: boolean;
  };
}

export const loanApplicationCreate = async (payload: IApplicationPayload) => {
  try {
    const response = await axios.post<{ data: ILoanApplicationCreateResponse }>(
      "/api/graphql",
      {
        query: LOAN_APPLICATION_CREATE_MUTATION,
        variables: { input: payload },
      },
    );

    // TODO: Discuss this with Kristian, shutting down the errors for now

    // @ts-expect-error - shut errors for now
    if (response.data.errors) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw response.data;
    }
    const data = response.data.data.createLoanApplication;

    if (data.__typename === "OperationInfo") {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw data;
    }

    deleteUtmParamsFromCookie();

    return data;
  } catch (err) {
    console.error(`Error creating loan application: ${err}`);
    throw err;
  }
};
